import { __decorate } from "tslib";
import { hasRight } from "@/store/helper";
import { SettingModule } from "@/store/modules/settings.module";
import { RightsConstant } from "@/store/securityRightConstant";
import { Guid } from "guid-typescript";
import { Component, Vue } from "vue-property-decorator";
let BaseMixer = /** @class */ (() => {
    let BaseMixer = class BaseMixer extends Vue {
        constructor() {
            super(...arguments);
            this.emptyGuid = Guid.createEmpty();
        }
        // Scroll to Document Top
        scrollToTop() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
        // Set Focus to a HTML Input
        setFocusToInput(referenceName) {
            let theTextbox = this.$refs[referenceName];
            theTextbox.focus();
        }
        // Set Focus to a HTML Input and select the contents
        setFocusToInputAndSelect(referenceName) {
            let theTextbox = this.$refs[referenceName];
            theTextbox.focus();
            theTextbox.select();
        }
        // Validate an Observer within Vee-Validate
        validate(reference) {
            let form = this.$refs[reference];
            return form.validate();
        }
        // Validate a Provider within Vee-Validate
        validateProvider(reference) {
            let form = this.$refs[reference];
            return form.validate();
        }
        // Reset a Validation Observer or Provider
        reset(ref) {
            let form = this.$refs[ref];
            return form.reset();
        }
        formattedTimeString(seconds) {
            let date = new Date(0);
            date.setSeconds(seconds);
            return date.toISOString().substr(11, 8);
        }
        formattedTime(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            return `${hours}h ${minutes}m`;
        }
        dateFormattedString(inputDate) {
            var newDate = new Date(inputDate);
            var currentMonth = newDate.getMonth() + 1;
            var month = currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;
            var currentDate = newDate.getDate();
            var date = currentDate < 10 ? `0${currentDate}` : `${currentDate}`;
            return `${month}/${date}/${newDate.getFullYear()}`;
        }
        dateFormatString(inputDate) {
            var newDate = new Date(inputDate);
            var currentMonth = newDate.getMonth() + 1;
            var month = currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;
            var currentDate = newDate.getDate();
            var date = currentDate < 10 ? `0${currentDate}` : `${currentDate}`;
            return `${month}-${date}-${newDate.getFullYear()}`;
        }
        ImageValidator(profileImage) {
            const allowedMimeTypes = ["image/jpeg", "image/png"];
            const allowedExtensions = [".jpg", ".jpeg", ".png", ".svg"];
            const fileType = profileImage.type;
            const fileName = profileImage.name;
            const fileExtension = fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            if (allowedMimeTypes.includes(fileType) || allowedExtensions.includes("." + fileExtension)) {
                return true;
            }
            else {
                return false;
            }
        }
        ImageSizeValidator(profileImage) {
            const maxSize = 2 * 1024 * 1024;
            const fileSize = profileImage.size;
            if (fileSize <= maxSize) {
                return true;
            }
            else {
                return false;
            }
        }
        dateFormattedStringDDMMMYYYY(inputDate) {
            var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var newDate = new Date(inputDate);
            var currentMonth = newDate.getMonth();
            var month = months[currentMonth];
            var currentDate = newDate.getDate();
            var date = currentDate < 10 ? `0${currentDate}` : `${currentDate}`;
            var year = newDate.getFullYear();
            return `${date}-${month}-${year}`;
        }
        DateFormatPeriod(inputDate) {
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const newDate = new Date(inputDate);
            const currentMonth = newDate.getMonth();
            const month = months[currentMonth];
            const currentDate = newDate.getDate();
            const date = currentDate < 10 ? `0${currentDate}` : `${currentDate}`;
            const year = newDate.getFullYear();
            return `${date}${month}" "${year}`;
        }
        dateRangeFormattedString(startDate, endDate) {
            const formatDate = (inputDate) => {
                const options = { year: "numeric", month: "short", day: "numeric" };
                const newDate = new Date(inputDate);
                return newDate.toLocaleDateString(undefined, options);
            };
            return `${formatDate(startDate)} - ${formatDate(endDate)}`;
        }
        get rightsHelper() {
            return hasRight;
        }
        DateFormatForReportName(inputDate) {
            var year = inputDate.getFullYear().toString();
            var month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
            var day = inputDate
                .getDate()
                .toString()
                .padStart(2, "0");
            return `${year}-${month}-${day}`;
        }
        dateFormatted(inputDate) {
            var day = inputDate
                .getDate()
                .toString()
                .padStart(2, "0");
            var month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
            var year = inputDate.getFullYear().toString();
            return `${day}/${month}/${year}`;
        }
        get dateFormat() {
            return SettingModule.userDateFormat;
        }
        get rightsConstant() {
            return RightsConstant;
        }
        get admin() {
            return "ADMIN";
        }
        get analyst() {
            return "ANALYST";
        }
        get client() {
            return "CLIENT";
        }
    };
    BaseMixer = __decorate([
        Component({
            filters: {
                fourDecimals: function (value) {
                    if (!value)
                        return "0.0000";
                    return (Math.round(value * 10000) / 10000).toFixed(4);
                },
                twoDecimals: function (value) {
                    if (!value)
                        return "0.00";
                    return (Math.round(value * 100) / 100).toFixed(2);
                },
                dollar: function (value) {
                    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
                },
                dollarPrecise: function (value) {
                    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(value);
                },
            },
        })
    ], BaseMixer);
    return BaseMixer;
})();
export default BaseMixer;
